"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.projectUid = exports.appName = void 0;

var _pathToRegexp = require("path-to-regexp");

const path = "/:appName/photos/projects/:projectUid/(.*)?";
const match = (0, _pathToRegexp.match)(path, {
  decode: window.decodeURIComponent
});
const {
  params
} = match(window.location.pathname);
let projectUid = "";
exports.projectUid = projectUid;
let appName = "";
exports.appName = appName;

if (params) {
  exports.projectUid = projectUid = params.projectUid;
  exports.appName = appName = params.appName;
}